import './tallguyandgrill4/style';
import FormStructure from './tallguyandgrill4/form_structure';

export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js